import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

var _sizes;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import classNames from 'classnames';
import { node, bool, string, object, oneOf } from 'prop-types';
import MuiButton from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
var SMALL_SIZE = 'small';
var MEDIUM_SIZE = 'medium';
var LARGE_SIZE = 'large';
var sizes = (_sizes = {}, _defineProperty(_sizes, SMALL_SIZE, 20), _defineProperty(_sizes, MEDIUM_SIZE, 22), _defineProperty(_sizes, LARGE_SIZE, 24), _sizes);

var styles = function styles(_ref) {
  var mixins = _ref.mixins,
      palette = _ref.palette;
  return {
    root: {
      display: 'inline-flex',
      position: 'relative'
    },
    fullWidth: {
      width: '100%'
    },
    progressContainer: _objectSpread({}, mixins.flex('center', 'center'), {}, mixins.position('absolute', 0, 0, 0, 0)),
    loader: {
      color: palette.primary.main
    },
    dangerButtonText: {
      color: palette.error.extraDark,
      '&:hover': {
        backgroundColor: palette.error.extraLight
      }
    },
    dangerButtonContained: {
      color: palette.common.white,
      backgroundColor: palette.error.main,
      '&:hover': {
        backgroundColor: palette.error.extraDark
      }
    },
    dangerButtonOutlined: {
      color: palette.error.main,
      border: "1px solid ".concat(palette.error.extraDark),
      '&:hover': {
        backgroundColor: palette.error.extraLight
      }
    }
  };
};

var MATERIAL_UI_BUTTON_COLORS = ['primary', 'secondary', 'default', 'inherit']; // eslint-disable-next-line prefer-arrow-callback

export var Button = React.forwardRef(function Button(props, ref) {
  var _classNames2;

  var ButtonProps = props.ButtonProps,
      children = props.children,
      classes = props.classes,
      className = props.className,
      color = props.color,
      disabled = props.disabled,
      fullWidth = props.fullWidth,
      loading = props.loading,
      ProgressProps = props.ProgressProps,
      size = props.size,
      variant = props.variant,
      rest = _objectWithoutProperties(props, ["ButtonProps", "children", "classes", "className", "color", "disabled", "fullWidth", "loading", "ProgressProps", "size", "variant"]);

  var wrapperClass = classNames(classes.root, className, _defineProperty({}, classes.fullWidth, fullWidth));
  var progressClass = classNames(ProgressProps.className, classes.loader);
  var buttonRootClasses = classNames((_classNames2 = {}, _defineProperty(_classNames2, classes.dangerButtonText, color === 'danger' && variant === 'text'), _defineProperty(_classNames2, classes.dangerButtonOutlined, color === 'danger' && variant === 'outlined'), _defineProperty(_classNames2, classes.dangerButtonContained, color === 'danger' && variant === 'contained'), _classNames2));
  var muiColor = MATERIAL_UI_BUTTON_COLORS.includes(color) ? color : 'default';
  return React.createElement("div", {
    className: wrapperClass,
    ref: ref
  }, React.createElement(MuiButton, _extends({
    color: muiColor,
    className: buttonRootClasses,
    classes: ButtonProps.classes,
    disabled: disabled || loading,
    fullWidth: fullWidth,
    variant: variant,
    size: size
  }, ButtonProps, rest), children), loading && React.createElement("div", {
    className: classes.progressContainer
  }, React.createElement(CircularProgress, _extends({
    className: progressClass,
    size: sizes[size]
  }, ProgressProps))));
});
process.env.NODE_ENV !== "production" ? Button.propTypes = {
  children: node.isRequired,
  classes: object.isRequired,
  ButtonProps: object,
  ProgressProps: object,
  className: string,
  color: oneOf(['primary', 'secondary', 'danger', 'default', 'inherit']),
  disabled: bool,
  fullWidth: bool,
  loading: bool,
  size: string,
  variant: oneOf(['text', 'outlined', 'contained'])
} : void 0;
Button.defaultProps = {
  ButtonProps: {
    classes: {}
  },
  className: '',
  color: 'default',
  disabled: false,
  fullWidth: false,
  loading: false,
  ProgressProps: {},
  size: MEDIUM_SIZE,
  variant: 'text'
};
export default withStyles(styles, {
  name: 'Button'
})(Button);